import { defineMessages } from 'react-intl';

export default defineMessages({
  quantity: {
    id: 'components.ProductLayout.title',
    defaultMessage: 'Quantity',
  },
  mediaIntegrtion: {
    id: 'pricing.actions.message',
    defaultMessage:
      "MediaIntegration is NI's authorized hardware distributor in Japan",
  },
});
